export default __webpack_public_path__ + "static/media/order3.84d5d6cd.svg";